import { render, staticRenderFns } from "./NewOrderFOBAlert.vue?vue&type=template&id=5635999f&"
import script from "./NewOrderFOBAlert.vue?vue&type=script&lang=js&"
export * from "./NewOrderFOBAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports